const deviceStatus = {
  active: 'active',
  notActive: 'not_active',
};

export default deviceStatus;
